import React from 'react';
import './SkeletonLoader.css';

/**
 * Skeleton Loader - Affichage pendant le chargement des données CRM
 * Donne une impression de chargement rapide
 */
const SkeletonLoader = () => {
  return (
    <div className="skeleton-container">
      <div className="skeleton-header">
        <div className="skeleton-avatar"></div>
        <div className="skeleton-text-group">
          <div className="skeleton-title"></div>
          <div className="skeleton-subtitle"></div>
        </div>
      </div>
      
      <div className="skeleton-section">
        <div className="skeleton-section-title"></div>
        <div className="skeleton-item"></div>
        <div className="skeleton-item"></div>
      </div>
      
      <div className="skeleton-section">
        <div className="skeleton-section-title"></div>
        <div className="skeleton-item"></div>
        <div className="skeleton-item"></div>
        <div className="skeleton-item"></div>
      </div>
    </div>
  );
};

export default SkeletonLoader;
